import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import reactCSS from 'reactcss';
import {Popover, Tooltip} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {BlockPicker, ChromePicker, SketchPicker} from "react-color";
import FieldWrapper from "../FieldWrapper";
import {chartColors} from "../../../ChartUtils/chartUtils";
import findByString from "../Utils/getValueByString";
import {setArrayPath} from "../Utils/setArrayPath";

const ColorPickerType = props => {
    const {field, setValue, labelStyles, fieldStyles, showLabel, values, colors, pickerType, containerArrayPath} = props;
    const [anchorEl, setAnchorEl] = useState(null)
    const [path, setPath] = useState(field.path)
    const [fieldValue, setFieldValue] = useState('');
    const [initialValue, setInitialValue] = useState('');
    const styles = reactCSS({
        'default': {
            color: {
                width: '100%',
                height: '14px',
                borderRadius: '2px',
                background: fieldValue || 'rgba(0,0,0,1)'
            },
            swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'flex',
                cursor: 'pointer',
                width: '100%',
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    });
    let arrayPath = setArrayPath(field.path, containerArrayPath);
    let value = findByString(values, arrayPath ? arrayPath : field.path);
    useEffect(() => {
        setPath(arrayPath ? arrayPath : field.path);
    }, [field.path, arrayPath]);
    useEffect(() => {
        value && setFieldValue(value ? value : '');
        value && setInitialValue(value ? value : '')
    }, [value])

    return (
        <div style={{padding: '3px 0'}}>
            <FieldWrapper
                label={field.label}
                labelStyles={labelStyles}
                fieldStyles={fieldStyles}
                path={field.path}
                showLabel={showLabel}
            >
                <div
                    style={styles.swatch}
                    onClick={e => setAnchorEl(e.currentTarget)}
                >
                    <Tooltip title={'Select Color'}>
                        <div style={styles.color}/>
                    </Tooltip>
                </div>
                <Popover open={Boolean(anchorEl)}
                         onClose={() => {
                             setAnchorEl(null)
                             setFieldValue(initialValue)
                         }}
                         anchorEl={anchorEl}
                         anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                         transformOrigin={{vertical: 'top', horizontal: 'center'}}
                >
                    <SwitchPicker
                        path={'path'}
                        type={pickerType}
                        color={fieldValue}
                        name={''}
                        onChange={(value) => setFieldValue(value.hex)}
                        colors={colors || chartColors}
                    />
                    <PopoverActions
                        complete={() => setValue(fieldValue, path)}
                        close={() => {
                            setAnchorEl(null)
                            setFieldValue(initialValue)
                        }}
                    />
                </Popover>
            </FieldWrapper>
        </div>
    );
};

ColorPickerType.propTypes = {
    field: PropTypes.object,
    setValue: PropTypes.func,
    labelStyles: PropTypes.object,
    fieldStyles: PropTypes.object,
    showLabel: PropTypes.bool,
    values: PropTypes.object,
    colors: PropTypes.array,
    pickerType: PropTypes.oneOf(['sketch', 'chrome', 'block'])
};
ColorPickerType.defaultProps = {
    setValue: () => {},
    field: {},
    colors: chartColors,
}

export default ColorPickerType;


const SwitchPicker = ({type, color, onChange, colors}) => {
    switch (type) {
        case 'sketch':
            return <SketchPicker
                color={color}
                onChangeComplete={(color) => onChange(color)}
            />;
        case 'chrome':
            return <ChromePicker
                color={color}
                onChangeComplete={(color) => onChange(color)}
            />;
        case 'block':
            return <BlockPicker
                color={color}
                onChangeComplete={(color) => onChange(color)}
                colors={colors}
            />;
        default:
            return <SketchPicker
                color={color}
                onChangeComplete={(color) => onChange(color)}
            />;
    }
};

const PopoverActions = ({complete, close}) => {
    return (
        <div style={{display: 'flex', justifyContent: 'flex-end', margin: '5px 0'}}>
            <Button
                onClick={() => {
                    complete();
                    close()
                }}
                variant={"contained"}
                color={"primary"}
                size={"small"}
                style={{marginRight: 5}}
            >
                Apply
            </Button>
            <Button onClick={close} variant={"contained"} color={"default"} size={"small"}>Cancel</Button>
        </div>
    )
};